import React, { Component } from 'react'

export class BlogItem extends Component {
   render() {
      return (
         <div className='blog_item--box'>
            <div className="image_box">
               <img src={"./img/TrendImg/" + this.props.item.foto} />
               <div><h3>{this.props.item.category}</h3></div>
            </div>
            <div className="blog--content">
               <h2>{this.props.item.title}</h2>
               <div className="blog_title--content">
                  <h3>{this.props.item.date}</h3>
                  <button className='project--button'>
                     <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                        <g clip-path="url(#clip0_2_230)">
                           <path d="M1.771 14.6859L7.71386 8.00017L1.771 1.31445" stroke="#292F36" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                           <clipPath id="clip0_2_230">
                              <rect width="9" height="16" fill="white" />
                           </clipPath>
                        </defs>
                     </svg>
                  </button>
               </div>
            </div>
         </div>
      )
   }
}

export default BlogItem
